import styled from "styled-components";

export const ContainerBody = styled.div`
  min-height: 100vh;
  width: 100%;
  display: grid;
  grid-template-rows: auto 1fr auto;
  background-color: #f7f7f7;
  max-width: 1920px;
  margin: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  div {
    max-width: 1920px;
  }
`;
